// Sub-popup-ul cu discuția unui elev, deschis din profilul lui („Mesaje”): apare din dreapta,
// după profil, ca restul sub-popup-urilor (SubPopupUI: rama, „Închide”). Arată doar discuția —
// mesajele și locul de scris (StudentProfileChat), fără lista de conversații, fără „Profil” și
// fără „Înapoi”.
import React from "react";

import { StudentProfileChat } from "../StaffChatPopup";

export default function StudentChatSubPopup({ student }) {
   const name = [student?.firstName, student?.lastName].filter(Boolean).join(" ").trim() || "Elev";
   return (
      <div className="studentChatSubPopup">
         <div className="studentChatSubPopup__header">
            <h3 className="studentChatSubPopup__title">{name}</h3>
            {student?.phone ? <p className="studentChatSubPopup__meta">{student.phone}</p> : null}
         </div>
         <StudentProfileChat student={student} />
      </div>
   );
}
